import { getStoreAuthToken } from "../context/auth";

const postObj = {
  method: "POST",
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  },
  credentials:"include",
  body: {}
};

export async function checkSession(callback, params) {
  params.token = getStoreAuthToken();
  params.token = params.token.replace(/^"|"$/g, "");
  const newPostObj = { ...postObj, body: JSON.stringify(params) };
  const response = await fetch(
    "https://gp.what-if.technology/api/user/checkSession",
    newPostObj
  );
  const json = await response.json();
  callback(json);
}


/*
const REST_API_URL = "https://https://gp.what-if.technology/api/user/checkSession";

export function checkSession(token) {
  axios
    .post(REST_API_URL, {
      token:token
    })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      return { success: false, data: {} };
    });
    
}*/

